const TRACKING_SIGNATURE = '__cmp_ui_tracking\n'

export const postTrackingEvent = (event: string): void => {
  window.top.postMessage(TRACKING_SIGNATURE + event, '*')
}
